<template>
  <transition
    :enter-active-class="transition.enter"
    :leave-active-class="transition.leave">
    <div
      :id="elementId"
      v-show="isActive"
      class="snackbar"
      :class="[type,position, request.isFamilyDoctor ? 'family-doctor' : '']">
      <span v-if="request.isFamilyDoctor && request.status === 'unicasted'" class="pl-2 w-8"><img src="../../../assets/personal_patient.svg" alt="Personal Patient"></span>
      <span v-if="request.isFamilyDoctor && request.status === 'queried'" class="pl-2 w-8"><img src="../../../assets/missed.svg" alt="Personal Patient"></span>
      <p class="text text-sm">{{ message }}</p>
      <div
        v-if="actionText"
        class="action flex flex-row"
        :class="type">
        <div>
          <button @click="action" v-if="request.isFamilyDoctor && request.status === 'unicasted'" class="button is-green"><div class="text-sm">{{ actionText }}</div></button>
          <button @click="action" v-else-if="request.isFamilyDoctor && request.status === 'queried'" class="button is-red"><div class="text-sm">{{ actionText }}</div></button>
          <button @click="action" v-else-if="!request.isFamilyDoctor" class="button is-dark"><div class="text-sm">{{ actionText }}</div></button>
        </div>
        <button class="button is-dark" @click="this.close"><img class="w-3" src="../../../assets/delete.svg"></button>
      </div>
    </div>
  </transition>
</template>

<script>
import config from './config'
import NoticeMixin from './NoticeMixin.js'
export default {
  name: 'BSnackbar',
  mixins: [NoticeMixin],
  props: {
    actionText: {
      type: String,
      default: 'OK'
    },
    onAction: {
      type: Function,
      default: () => {}
    },
    indefinite: {
      type: Boolean,
      default: false
    },
    elementId: {
      type: String,
      default: 'temp'
    },
    request: {
      type: Object,
      default: {status: 'broadcasted'}
    }
  },
  data () {
    return {
      newDuration: this.duration || config.defaultSnackbarDuration
    }
  },
  methods: {
    /**
     * Click listener.
     * Call action prop before closing (from Mixin).
     */
    action () {
      this.onAction()
      this.close()
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/common/snackbar/Snackbar.vue